<script>
export default {
    name: "VisitTreatment",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500
                     rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,

        };
    },

    props: {
        showModal: Boolean,
        patient: {
            type: Object,
            required: true,
        },
    },

    components: {
        "vitals-tab": () => import('./tabs/Vitals.vue'),
        "diagnosis-tab": () => import('./tabs/Diagnosis.vue'),
        "treatment-tab": () => import('./tabs/Treatment.vue'),
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Visit Treatment</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="md:w-1/5 sm:w-1/2 p-1">
          <h5 class="font-semibold text-sm">
              Patient: <span class="text-blue-800 text-sm">{{ patient.names }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Id No/Passport: </span>
            <span class="font-semibold text-blue-800 text-sm">
                {{ patient.nationalid || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">IP File No: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.ipfileno || ' -' }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">OP File No: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.opfileno || ' -'}}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">DOB: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.dob | dateFormat }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Gender: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.gender || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Cellphone: </span>
            <span class="font-semibold text-blue-800">
                {{patient.celL_PHONE || " -" }}</span></h5>
        </div>
        <div class="md:w-1/5 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Other Cellphone: </span>
            <span class="font-semibold text-blue-800">
                {{patient.otheR_PHONE || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Employment: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.employment || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Employer: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.employer || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Residence: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.residence || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">County: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.county || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Location: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.location || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Sublocation: </span>
            <span class="font-semibold text-blue-800">
                {{ patient.sublocation || " -" }}</span></h5>
        </div>
    </div>
    <ul
      class="flex border-b-2 border-gray-500"
    >
      <li class="-mb-px mr-1">
        <a
          href="javascript:void(0)"
          @click.prevent="active = 0"
          class="btn-sm text-base text-gray-900 rounded-t-md inline-block 
                            px-4 font-bold whitespace-no-wrap"
          :class="active === 0 ? activeClass : inActiveClass"
          >
          Vitals
        </a>
      </li>
      <li class="-mb-px mr-1">
        <a
          href="javascript:void(0)"
          @click.prevent="active = 1"
          class="btn-sm text-base text-gray-900 rounded-t-md inline-block 
                            px-4 font-bold whitespace-no-wrap"
          :class="active === 1 ? activeClass : inActiveClass"
          >
          Diagnosis
        </a>
      </li>
      <li class="-mb-px mr-1">
        <a
          href="javascript:void(0)"
          @click.prevent="active = 2"
          class="btn-sm text-base text-gray-900 rounded-t-md inline-block 
                            px-4 font-bold whitespace-no-wrap"
          :class="active === 2 ? activeClass : inActiveClass"
          >
          Prescriptions
        </a>
      </li>
    </ul>
    <vitals-tab :patient="patient" v-if="active == 0" />
    <diagnosis-tab :patient="patient" v-if="active == 1" />
    <treatment-tab :patient="patient" v-if="active == 2" />
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded" 
        @click.prevent="$emit(`closeModal`)">Close</button>
  </template>
</tail-modal>
</template>
